import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { desencriptarPrestador } from "../../redux/actions/operationActions";
import { getPrestador } from "../../redux/selectors";
import { RouteComponentProps } from "react-router-dom";

interface MatchParams {
  prestador : string
}

interface IRedirect extends RouteComponentProps<MatchParams> {
}

export const Redirect: React.FC<IRedirect> = (props) => {
  const { match, history } = props;
  const dispatch = useDispatch();
  const prestador = useSelector((state) => getPrestador(state));

  useEffect(() => {
    const valor = match.params.prestador;
    if (!prestador && !sessionStorage.getItem('accessToken')) dispatch(desencriptarPrestador(valor));
    history.push('/');
  });

  return null;
};

export default Redirect;
